import React from "react";
import PoModificationCreation from "./poModificationCreation";

const initialColumns = [
    { id: "description", label: "Description", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "hsnSacCode", label: "HSN Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "uom", label: "Unit", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "quantity", label: "Total Qty", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "newValue", label: "New Qty", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "INPUT_TEXT" },
  ];

function PoQtyModificationCreation() {
  
  return (
    <>
      <PoModificationCreation 
        initialColumns={initialColumns}
        componentName="QTY_MODIFICATION"  
        lineItemName="boqs"        
      />
    </>
  )
}

export default PoQtyModificationCreation;